module.exports = __webpack_public_path__ + "project-variable-template.2f233c5b616e40cd88a4b68df742ff6e.hashedasset.svg";